module.exports = __webpack_public_path__ + "img/logo.a06ba49b.png";